
export default {
  name: 'CardPremium',
  props: {
    name: {
      type: String,
      default: '',
    },
    role: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '#000',
    },
    price: {
      type: Number,
      default: 0,
    },
    server: {
      type: Number,
      default: 0,
    },
    popular: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pricePerServer() {
      return this.price / this.server
    },
  },
}
